<template>
  <div :class="['simpleSales', diffFlag?'overH':'' ]">
    <div class="main_bgc">
      <img src="../assets/image/Login/bgc.png">
      <div class="footer_btn" @click="handleClick">
        <img src="../assets/image/Login/btn.png">
      </div>
    </div>

    <div class="fill" ref="fill"></div>
    <!-- 弹框 -->
    <div class="box_bgc" @click="handleClickCancel" v-if="isShow"></div>
    <div class="content" v-if="isShow">
      <h4>提示</h4>
      <img src="../assets/image/Login/cancel.png" class="cancel" @click="handleClickGoto">
      <div class="box_info">
        <div>申请加入时，请输入</div>
        <div>代理商编码：A0000</div>
      </div>
      <button class="box_btn" @click="handleClickGoto">确定</button>
    </div>
  </div>
</template>

<script>
import common from '../utils/common';
import constants from '../utils/constants';
export default {
  data() {
    return {
      isShow: false,
      diffFlag: false
    };
  },
  mounted() {
    this.$nextTick(function () {
      window.scrollTo(0, 0)
      setTimeout(()=> {
        if(this.$refs.fill.offsetHeight > 0){
          this.diffFlag = true
        }
      }, 300)
      /* 微信分享 */
      common.wxShare(this, constants.SIMPLESALES);
    });
  },
  methods: {
    handleClick() {
      this.isShow = true;
    },
    handleClickCancel() {
      this.isShow = false;
    },
    handleClickGoto() {
      // window.location.href = "http://chejia-0ggrx5lva5901b08-1305273491.tcloudbaseapp.com/?path=addInformation"
      window.location.href =
        'http://chejia-0ggrx5lva5901b08-1305273491.tcloudbaseapp.com/?path=ss';
    },
  },
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
}

.simpleSales {
  position: relative;
  margin: 0 auto;
  max-width: 7.68rem;
  min-height:100vh;
  font-size: 0;
  display: flex;
  flex-flow: column nowrap;
  .main_bgc {
    position: relative;
    width: 100%;
    img {
      width: 100%;
    }
  }

  .fill {
    width: 100%;
    flex: 1;
    background: #94cbff;
  }

  .footer_btn {
    position: absolute;
    bottom: 0.3rem;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      margin: 0 auto;
      width: 6.76rem;
      height: 1.18rem;
    }
  }

  // 弹框
  .box_bgc {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    position: absolute;
    top: 35%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 5.84rem;
    height: 3.3rem;
    background-color: #fff;
    border-radius: 0.08rem;
    text-align: center;
    h4 {
      margin: 0.3rem 0 0.24rem 0;
      font-size: 0.32rem;
      color: #333333;
      line-height: 0.36rem;
    }
    .cancel {
      position: absolute;
      top: 0.28rem;
      right: 0.32rem;
      width: 0.4rem;
      height: 0.4rem;
    }
    .box_info {
      font-size: 0.34rem;
      color: #333333;
      line-height: 0.4rem;
    }
    .box_btn {
      margin: 0.39rem auto;
      font-family: PingFangSC-Medium;
      width: 4.4rem;
      height: 0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #3289ff;
      border-radius: 0.45rem;
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.4rem;
      border: none;
    }
  }
}

.overH {
  overflow: hidden;
  .footer_btn {
    bottom: 0;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/partner.vue